import { ProductEnergy } from '../../../../../generated/graphql';
import { ILabel } from '../../../models/common/label.model';
import { IProductService } from '../../../services/product/product-service';

export type EnergyLabelProductInfoProps = {
  energyArea: ProductEnergy;
  labels?: ILabel[];
  productService?: IProductService;
  stockCode: string;
  className?: string;
  ratingLetterFontSize?: number;
  euElrProductInformationSheetUrl?: string;
  onModalToggleCallback?: (isOpen: boolean) => void;
  onUnavailableEnergyProductInfoSheetBtnClick?: () => void;
};

export type State = {
  euElrProductInformationSheetUrl?: string;
  energyProductInfoSheetNotFound: boolean;
  isEnergyProductInfoSheetBtnDisabled: boolean;
  isUnavailableEnergyProductInfoSheetBtnClicked?: boolean;
};

export enum EnergyLabelProductInfoActionType {
  SetIsUnavailableEnergyProductInfoSheetBtnClicked = 'SetIsUnavailableEnergyProductInfoSheetBtnClicked',
  SetEuElrProductInformationSheet = 'SetEuElrProductInformationSheet',
}

export type Action =
  | { type: EnergyLabelProductInfoActionType.SetIsUnavailableEnergyProductInfoSheetBtnClicked }
  | { type: EnergyLabelProductInfoActionType.SetEuElrProductInformationSheet; url?: string };
